import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SITE } from '../content';
import { Film } from '../film/film';
import { FilmAction } from '../film/film.types';
import { CINEMA_CHAPTERS } from './chapters';

/** "Ultimate Cinema Seating": a 3D tour of a multiplex hall fitted with Little Nap recliners. */
@Component({
  selector: 'app-cinema',
  imports: [Film],
  templateUrl: './cinema.html',
  styleUrl: './cinema.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Cinema {
  protected readonly chapters = CINEMA_CHAPTERS;
  protected readonly actions: FilmAction[] = [
    { label: 'Explore Multiplex Recliners', href: `${SITE}/multiplex-recliners`, kind: 'primary', external: true },
    { label: 'Plan Your Cinema', href: '#enquire', kind: 'ghost' },
  ];
  /** the 3D scene is its own chunk, fetched when the section nears the viewport */
  protected readonly loader = () => import('./cinema-scene').then((m) => m.CinemaScene);
}
